import { edit } from 'brace';
import 'brace/mode/text';
import 'brace/theme/github';
import { InjectionToken, EventEmitter, Directive, NgZone, ElementRef, KeyValueDiffers, Optional, Inject, Input, Output, Component, ViewEncapsulation, HostBinding, ViewChild, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
const ACE_CONFIG = new InjectionToken('ACE_CONFIG');
const AceEditorEvents = [
    'blur',
    'focus',
    'copy',
    'paste',
    'change',
    'changeSession'
];
const AceSelectionEvents = [
    'changeCursor',
    'changeSelection'
];
class AceConfig {
    constructor(config = {}) {
        this.assign(config);
    }
    assign(config = {}, target) {
        target = target || this;
        for (const key in config) {
            if (config[key] && !Array.isArray(config[key]) && typeof config[key] === 'object') {
                target[key] = {};
                this.assign(config[key], target[key]);
            }
            else {
                target[key] = config[key];
            }
        }
    }
}

class AceDirective {
    constructor(zone, elementRef, differs, defaults) {
        this.zone = zone;
        this.elementRef = elementRef;
        this.differs = differs;
        this.defaults = defaults;
        this.instance = null;
        this.configDiff = null;
        this.disabled = false;
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.copy = new EventEmitter();
        this.paste = new EventEmitter();
        this.change = new EventEmitter();
        this.changeCursor = new EventEmitter();
        this.changeSession = new EventEmitter();
        this.changeSelection = new EventEmitter();
    }
    ngOnInit() {
        const params = new AceConfig(this.defaults);
        params.assign(this.config); // Custom configuration
        if (this.disabled) {
            params.readOnly = true;
            params.highlightActiveLine = false;
        }
        params.mode = 'ace/mode/' + (params.mode || 'text');
        params.theme = 'ace/theme/' + (params.theme || 'github');
        this.zone.runOutsideAngular(() => {
            this.instance = edit(this.elementRef.nativeElement);
            this.instance.$blockScrolling = Infinity;
            this.instance.setOptions(params);
        });
        // Add native Ace event handling
        AceEditorEvents.forEach((eventName) => {
            if (this.instance) {
                this.instance.on(eventName, (...args) => {
                    if (args.length === 1) {
                        args = args[0];
                    }
                    if (this[eventName]) {
                        this.zone.run(() => {
                            if (this[eventName].observers.length) {
                                this[eventName].emit(args);
                            }
                        });
                    }
                });
            }
        });
        // Add native Ace selection event handling
        AceSelectionEvents.forEach((eventName) => {
            if (this.instance) {
                this.instance.selection.on(eventName, (...args) => {
                    if (args.length === 1) {
                        args = args[0];
                    }
                    if (this[eventName]) {
                        if (this[eventName].observers.length) {
                            this[eventName].emit(args);
                        }
                    }
                });
            }
        });
        if (!this.configDiff) {
            this.configDiff = this.differs.find(this.config || {}).create();
            this.configDiff.diff(this.config || {});
        }
    }
    ngDoCheck() {
        if (this.configDiff) {
            const changes = this.configDiff.diff(this.config || {});
            if (changes) {
                this.ngOnDestroy();
                this.ngOnInit();
            }
        }
    }
    ngOnDestroy() {
        if (this.instance) {
            if (this.instance.isFocused()) {
                this.blur.emit();
            }
            delete this.instance;
            this.instance = null;
        }
    }
    ngOnChanges(changes) {
        if (changes['disabled']) {
            if (changes['disabled'].currentValue !== changes['disabled'].previousValue) {
                this.zone.runOutsideAngular(() => {
                    if (this.instance) {
                        const params = new AceConfig(this.defaults);
                        params.assign(this.config); // Custom configuration
                        this.instance.clearSelection();
                        const hlActive = (params.highlightActiveLine == null) ? true : false;
                        this.instance.setHighlightActiveLine(this.disabled ? false : hlActive);
                        this.instance.setReadOnly(this.disabled ? true : (params.readOnly || false));
                    }
                });
            }
        }
    }
    ace() {
        return this.instance;
    }
    clear() {
        if (this.instance) {
            this.instance.setValue('');
            this.instance.clearSelection();
        }
    }
    getValue() {
        if (this.instance) {
            return this.instance.getValue();
        }
    }
    setValue(value, cursorPos) {
        if (this.instance) {
            this.instance.setValue(value || '', cursorPos);
        }
    }
}
AceDirective.ɵfac = function AceDirective_Factory(t) { return new (t || AceDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.KeyValueDiffers), ɵngcc0.ɵɵdirectiveInject(ACE_CONFIG, 8)); };
AceDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AceDirective, selectors: [["", "ace", ""]], inputs: { disabled: "disabled", config: ["ace", "config"] }, outputs: { blur: "blur", focus: "focus", copy: "copy", paste: "paste", change: "change", changeCursor: "changeCursor", changeSession: "changeSession", changeSelection: "changeSelection" }, exportAs: ["ngxAce"], features: [ɵngcc0.ɵɵNgOnChangesFeature] });
AceDirective.ctorParameters = () => [
    { type: NgZone },
    { type: ElementRef },
    { type: KeyValueDiffers },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [ACE_CONFIG,] }] }
];
AceDirective.propDecorators = {
    disabled: [{ type: Input }],
    config: [{ type: Input, args: ['ace',] }],
    blur: [{ type: Output }],
    focus: [{ type: Output }],
    copy: [{ type: Output }],
    paste: [{ type: Output }],
    change: [{ type: Output }],
    changeCursor: [{ type: Output }],
    changeSession: [{ type: Output }],
    changeSelection: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AceDirective, [{
        type: Directive,
        args: [{
                selector: '[ace]',
                exportAs: 'ngxAce'
            }]
    }], function () { return [{ type: ɵngcc0.NgZone }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.KeyValueDiffers }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [ACE_CONFIG]
            }] }]; }, { disabled: [{
            type: Input
        }], blur: [{
            type: Output
        }], focus: [{
            type: Output
        }], copy: [{
            type: Output
        }], paste: [{
            type: Output
        }], change: [{
            type: Output
        }], changeCursor: [{
            type: Output
        }], changeSession: [{
            type: Output
        }], changeSelection: [{
            type: Output
        }], config: [{
            type: Input,
            args: ['ace']
        }] }); })();

class AceComponent {
    constructor() {
        this.content = '';
        this.disabled = false;
        this.mode = '';
        this.theme = '';
        this.useAceClass = true;
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.copy = new EventEmitter();
        this.paste = new EventEmitter();
        this.change = new EventEmitter();
        this.valueChange = new EventEmitter();
        this.changeCursor = new EventEmitter();
        this.changeSession = new EventEmitter();
        this.changeSelection = new EventEmitter();
    }
    get value() {
        return this.content;
    }
    set value(value) {
        this.setContent(value);
    }
    ngAfterViewInit() {
        if (this.content != null) {
            this.setContent(this.content, true);
        }
    }
    setContent(value, force) {
        if (force || value !== this.content) {
            if (this.directiveRef) {
                this.directiveRef.setValue(value, 1);
            }
            this.content = value;
        }
    }
    getConfig() {
        this.config = this.config || {};
        this.config.mode = this.mode || this.config.mode;
        this.config.theme = this.theme || this.config.theme;
        return this.config;
    }
    onContentChange(event) {
        if (this.directiveRef) {
            this.change.emit(event);
            this.content = this.directiveRef.getValue() || '';
            this.valueChange.emit(this.value);
        }
    }
}
AceComponent.ɵfac = function AceComponent_Factory(t) { return new (t || AceComponent)(); };
AceComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AceComponent, selectors: [["ace"]], viewQuery: function AceComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(AceDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.directiveRef = _t.first);
    } }, hostVars: 2, hostBindings: function AceComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("ace", ctx.useAceClass);
    } }, inputs: { disabled: "disabled", mode: "mode", theme: "theme", useAceClass: "useAceClass", value: "value", config: "config" }, outputs: { blur: "blur", focus: "focus", copy: "copy", paste: "paste", change: "change", valueChange: "valueChange", changeCursor: "changeCursor", changeSession: "changeSession", changeSelection: "changeSelection" }, exportAs: ["ngxAce"], decls: 1, vars: 2, consts: [[3, "ace", "disabled", "blur", "focus", "copy", "paste", "change", "changeCursor", "changeSession", "changeSelection"]], template: function AceComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("blur", function AceComponent_Template_div_blur_0_listener($event) { return ctx.blur.emit($event); })("focus", function AceComponent_Template_div_focus_0_listener($event) { return ctx.focus.emit($event); })("copy", function AceComponent_Template_div_copy_0_listener($event) { return ctx.copy.emit($event); })("paste", function AceComponent_Template_div_paste_0_listener($event) { return ctx.paste.emit($event); })("change", function AceComponent_Template_div_change_0_listener($event) { return ctx.onContentChange($event); })("changeCursor", function AceComponent_Template_div_changeCursor_0_listener($event) { return ctx.changeCursor.emit($event); })("changeSession", function AceComponent_Template_div_changeSession_0_listener($event) { return ctx.changeSession.emit($event); })("changeSelection", function AceComponent_Template_div_changeSelection_0_listener($event) { return ctx.changeSelection.emit($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ace", ctx.getConfig())("disabled", ctx.disabled);
    } }, directives: [AceDirective], styles: [".ace,.ace>.ace_editor{display:block;height:100%;width:100%}.ace[fxflex]{align-items:inherit;display:flex;flex-direction:inherit;min-height:0;min-width:0}.ace[fxflex]>.ace_editor{-webkit-box-flex:1;flex:1 1 auto;min-height:0;min-width:0}"], encapsulation: 2 });
AceComponent.ctorParameters = () => [];
AceComponent.propDecorators = {
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    mode: [{ type: Input }],
    theme: [{ type: Input }],
    config: [{ type: Input }],
    useAceClass: [{ type: HostBinding, args: ['class.ace',] }, { type: Input }],
    blur: [{ type: Output }],
    focus: [{ type: Output }],
    copy: [{ type: Output }],
    paste: [{ type: Output }],
    change: [{ type: Output }],
    valueChange: [{ type: Output }],
    changeCursor: [{ type: Output }],
    changeSession: [{ type: Output }],
    changeSelection: [{ type: Output }],
    directiveRef: [{ type: ViewChild, args: [AceDirective, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AceComponent, [{
        type: Component,
        args: [{
                selector: 'ace',
                exportAs: 'ngxAce',
                template: "<div [ace]=\"getConfig()\" [disabled]=\"disabled\" (blur)=\"blur.emit($event)\" (focus)=\"focus.emit($event)\" (copy)=\"copy.emit($event)\" (paste)=\"paste.emit($event)\" (change)=\"onContentChange($event)\" (changeCursor)=\"changeCursor.emit($event)\" (changeSession)=\"changeSession.emit($event)\" (changeSelection)=\"changeSelection.emit($event)\">\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".ace,.ace>.ace_editor{display:block;height:100%;width:100%}.ace[fxflex]{align-items:inherit;display:flex;flex-direction:inherit;min-height:0;min-width:0}.ace[fxflex]>.ace_editor{-webkit-box-flex:1;flex:1 1 auto;min-height:0;min-width:0}"]
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], mode: [{
            type: Input
        }], theme: [{
            type: Input
        }], useAceClass: [{
            type: HostBinding,
            args: ['class.ace']
        }, {
            type: Input
        }], blur: [{
            type: Output
        }], focus: [{
            type: Output
        }], copy: [{
            type: Output
        }], paste: [{
            type: Output
        }], change: [{
            type: Output
        }], valueChange: [{
            type: Output
        }], changeCursor: [{
            type: Output
        }], changeSession: [{
            type: Output
        }], changeSelection: [{
            type: Output
        }], value: [{
            type: Input
        }], config: [{
            type: Input
        }], directiveRef: [{
            type: ViewChild,
            args: [AceDirective, { static: true }]
        }] }); })();

class AceModule {
}
AceModule.ɵfac = function AceModule_Factory(t) { return new (t || AceModule)(); };
AceModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AceModule });
AceModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule], CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AceModule, [{
        type: NgModule,
        args: [{
                declarations: [AceComponent, AceDirective],
                imports: [CommonModule],
                exports: [CommonModule, AceComponent, AceDirective],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AceModule, { declarations: function () { return [AceComponent, AceDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CommonModule, AceComponent, AceDirective]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ACE_CONFIG, AceComponent, AceConfig, AceDirective, AceModule };

